import { PaymentMethod } from '@40seas/entities/payment-methods';
import { PaymentMethodType } from '@40seas/models';
import Stripe from 'stripe';
import { BACSPaymentMethod } from '../bacs-payment-method.entity';

export async function bacsPaymentMethodTypeHandler(stripePaymentMethod: Stripe.PaymentMethod): Promise<Partial<PaymentMethod>> {
    return {
        methodType: PaymentMethodType.BACS,
        methodTypeFields: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            last4: stripePaymentMethod.bacs_debit!.last4,
        } as BACSPaymentMethod,
    };
}
